import { getGlobals } from '../../globals';

const { uri } = getGlobals();

export const REDIRECT_URLS_MAP = {
  billing: `${uri.base}/webapps/billing`,
  dumbledore: `${uri.base}/checkoutweb`,
  forgotEmail: `${uri.base}/authflow/email-recovery/`,
  hermes: `${uri.base}/webapps/hermes`,
  organicSignup: `${uri.base}/welcome/signup`,
  pwRest: `${uri.base}/authflow/password-recovery/`,
  tesla: `${uri.base}/welcome/flow/signup`,
  xoon: `${uri.base}/webapps/xoonboarding`,
};
